<template>
  <CockpitCard cardType="default">
    <div class="flex flex-wrap h-300px w-full overflow-x-hidden">
      <div
        v-for="(item, index) in deviceList"
        :key="index"
        class="flex flex-col w-[calc(33%-6px)] mx-3px mb-8px"
      >
        <div
          class="text-14px text-hex-fff font-400 bg-opacity-40 h-27px !leading-27px text-center rounded-t-0.9px cursor-pointer"
          @click="showRight(item)"
          :class="colorCalc(index)"
        >
          {{ item.deviceType }}
        </div>
        <div
          class="border-1px border-dashed border-hex-fff border-opacity-30 !border-t-0 p-5px flex flex-col items-center"
        >
          <div
            class="h-29px leading-29px flex items-center bg-hex-28a3ca bg-opacity-12 font-400 text-12px text-hex-fff justify-between px-5px w-full"
          >
            <span
              v-if="['5G基站', '机柜'].includes(item.name)"
              class="text-hex-fff text-opacity-70"
            >
              总数
            </span>
            <span v-else class="text-hex-fff text-opacity-70">在线</span>
            <span v-if="['5G基站', '机柜'].includes(item.name)">{{ item.totalDevices }}</span>
            <span v-else>
              <span class="text-hex-58f2f0">{{ item.onlineDevices }}</span>
              /
              <span>{{ item.offlineDevices }}</span>
            </span>
          </div>
          <div
            class="h-29px mt-5px leading-29px flex items-center bg-hex-28a3ca bg-opacity-12 font-400 text-12px text-hex-fff justify-between px-5px w-full"
            v-if="!['5G基站', '机柜'].includes(item.name)"
          >
            <span class="text-hex-fff text-opacity-70">在线率</span>
            <span> {{ item.onlineRate }}% </span>
          </div>
        </div>
      </div>
    </div>
    <div class="h-20/100 w-full">
      <CategoryTitle title="服务器负载" />
      <v-chart
        :options="lineOption"
        :autoresize="true"
        class="w-full !h-[calc(100%-28px)] mt-10px"
        :init-options="{ devicePixelRatio: 2 }"
      ></v-chart>
    </div>

    <div class="w-full h-[calc(80%-320px)] mt-20px">
      <CategoryTitle title="数据管理" />
      <div class="flex items-center">
        <img
          class="mt-45px"
          src="../../../../assets/images/platform-monitoring-data-mangment.png"
          alt=""
        />
        <div>
          <div class="data-mangment-bg text-14px text-hex-ccedff leading-25px text-center my-10px">
            数据管理
          </div>
          <div class="flex flex-wrap justify-around">
            <div
              v-for="(item, index) in dataManagementList"
              :key="index"
              class="w-33/100 text-hex-fff"
              :class="item.class"
            >
              <div class="font-400 text-12px text-hex-d9dde0 h-17px !leading-17px mt-3px">
                {{ item.name }}
              </div>
              <div class="mt-5px">
                <span class="inline-block font-500 text-hex-d9dde0 text-20px mr-3px">{{
                  item.count
                }}</span>
                <span class="inline-block font-400 text-hex-7a8b96 text-10px">{{ item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-chart
        :options="pillarOption"
        :autoresize="true"
        class="!h-[calc(100%-181px)] w-full mt-10px"
        :init-options="{ devicePixelRatio: 2 }"
      ></v-chart>
    </div>
  </CockpitCard>
</template>

<script>
import { forEach, map, cloneDeep } from 'lodash'
// components
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import CockpitCard from '@/components/cockpit/CockpitCard'
// api
import { PlatformMonitorApi } from '@wiz-api/huizhou2-business'
import { OpenApiCallRecordApi } from '@wiz-api/open-api-management'

// init-data
import { pillarOption, lineOption } from '../ChartsOptions'

const platformMonitorApi = new PlatformMonitorApi()
const openApiCallRecordApi = new OpenApiCallRecordApi()

export default {
  data() {
    return {
      deviceList: [
        {
          deviceType: '服务器',
          name: '服务器',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '交换机',
          deviceType: '交换机',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '定位基站',
          deviceType: '定位基站',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '门禁',
          deviceType: '门禁',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '摄像头',
          deviceType: '摄像头',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '机柜',
          deviceType: '机柜',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
        {
          name: '5G基站',
          deviceType: '5G基站',
          offlineDevices: null,
          onlineDevices: null,
          onlineRate: null,
          totalDevices: null,
        },
      ],
      lineOption: cloneDeep(lineOption),
      pillarOption: cloneDeep(pillarOption),
      dataManagementList: [
        { name: '接入系统', count: 0, unit: '件', class: 'pl-10px mb-10px', prop: 'systemCount' },
        { name: '接入数据表', count: 0, unit: '件', class: 'mb-10px', prop: 'tableCount' },
        {
          name: '支撑应用数',
          count: 0,
          unit: '个',
          class: 'mb-10px',
          prop: 'supportedAppCount',
          type: 'api',
        },
        {
          name: 'API发布',
          count: 0,
          unit: '次',
          class: 'pl-10px',
          prop: 'apiPublishedCount',
          type: 'api',
        },
        { name: 'API调用', count: 0, unit: '次', prop: 'apiCallCount', type: 'api' },
        { name: '调用失败', count: 0, unit: '次', prop: 'callFailCount', type: 'api' },
      ],
    }
  },
  methods: {
    async getDeviceStastic() {
      const [err, res] = await platformMonitorApi.getDeviceStatistics()
      if (!err && res) {
        res.splice(4, 1, res.splice(6, 1, res[4])[0])
        res.splice(3, 1, res.splice(5, 1, res[3])[0])
        this.deviceList = res.map((it) => {
          if (it.deviceType === '通信基站') it.deviceType = '5G基站'
          if (it.deviceType === '监控') it.deviceType = '摄像头'
          it.name = it.deviceType
          return it
        })
      }
    },
    // 数据管理
    async getSystemStastic() {
      const [err, res] = await platformMonitorApi.systemStastic()
      if (!err) {
        forEach(this.dataManagementList, (item) => {
          if (!item.type) {
            item.count = res[item.prop]
          }
        })
      }
    },
    async getCpuLoad() {
      const [err, res] = await platformMonitorApi.computerCpuLoad()
      if (!err) {
        this.lineOption.xAxis.data = map(res, 'x')
        this.lineOption.series[0].data = map(res, 'y')
      }
    },
    // 数据管理
    async getSummary() {
      const [err, res] = await openApiCallRecordApi.getHuizhou2SummaryResult()
      if (!err) {
        forEach(this.dataManagementList, (item) => {
          if (item.type) {
            item.count = res[item.prop]
          }
        })
        this.pillarOption.xAxis.data = map(res.appCallDetails.error, 'x')
        this.pillarOption.series[0].data = map(res.appCallDetails.error, 'y')
        this.pillarOption.series[1].data = map(res.appCallDetails.success, 'y')
      }
    },
    showRight(item) {
      this.$emit('showRight', cloneDeep(item))
    },
    initOption() {
      this.lineOption.xAxis.axisLabel.interval = 0
    },
    colorCalc(index) {
      const columnOne = [0, 3, 6]
      const columnTow = [1, 4]
      if (columnOne.includes(index)) return 'bg-hex-53e0ff'
      if (columnTow.includes(index)) return 'bg-hex-59d4a0'
      return 'bg-hex-c3c06c'
    },
  },
  components: { CockpitCard, CategoryTitle },
  created() {
    this.initOption()
    this.getDeviceStastic()
    this.getSummary()
    this.getSystemStastic()
    this.getCpuLoad()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-progress--dashboard .el-progress__text {
  font-weight: 700 !important;
  font-size: 16px !important;
}
.data-mangment-bg {
  background-image: url('../../../../assets/images/platform-monitoring-data.png');
}
</style>
